import { registerMutation } from '@adornis/baseql/metadata/register.js';
import { getCollection } from '@adornis/baseql/server/collections.js';
import { MatchingRole } from '@adornis/bh-matching-user/roles.js';
import { Timeframe } from '@adornis/bh-timeframes/entities/Timeframe.js';
import { AdornisFilter } from '@adornis/filter/AdornisFilter.js';
import { GLOBAL_CONTEXT } from '@adornis/users/db/a-roles.js';
import { addRoleToUser, BaseUser, registerUser } from '@adornis/users/db/a-user.js';
import { MentoringMentor } from '../entities/mentoring-user.js';
import { resolveDownloadCurriculumVitae } from '../server/resolveDownloadCurriculumVitae.js';

export const registerMentoringAdminUser = registerMutation({
  operationName: 'registerMentoringAdminUser',
  resolve: (baseUser: BaseUser) => async () => {
    const userID = await registerUser({ ...baseUser.toObject() });
    await addRoleToUser(userID, MatchingRole.ADMIN, [GLOBAL_CONTEXT])();
  },
  type: () => Boolean,
  params: [{ name: 'baseUser', type: () => BaseUser }],
});

export const downloadBuddyUserCurriculumVitaes = registerMutation({
  operationName: 'downloadBuddyUserCurriculumVitaes',
  resolve: resolveDownloadCurriculumVitae,
  type: () => String,
  params: [
    { name: 'targetSemester', type: () => Timeframe },
    { name: 'filter', type: () => AdornisFilter },
  ],
});

export const updateMentorVisibility = registerMutation({
  operationName: 'updateMentorVisibility',
  type: () => Boolean,
  params: [
    { name: 'mentorId', type: () => String },
    { name: 'isHidden', type: () => Boolean },
  ],
  resolve: (mentorId: string, isHidden: boolean) => async () => {
    const collection = await getCollection(MentoringMentor._class);
    const result = await collection.updateOne({ _id: mentorId }, { $set: { hiddenFromMentees: isHidden } });
    return result.modifiedCount > 0;
  },
});

export namespace MentoringUserAPI {
  export const registerAdmin = registerMentoringAdminUser;
  export const downloadCurriculumVitaes = downloadBuddyUserCurriculumVitaes;
}
